import React, { useContext, useMemo, useCallback } from 'react';
import { Avatar, Box, Button, Checkbox, Typography, Stack, FormGroup, FormControlLabel } from '@mui/material';
import { AddBox1 } from '../../../../../../core/global/Icons';
import { ToolContext } from '../../../../../../core/context/ToolContext'
import { Clear, DeleteOutline } from '@mui/icons-material';
import { StndrdTextField } from "../../../../../../core/styling/form/CstmField"
import ReactQuill from 'react-quill';

const Content = ({ handleChange, validateFields }) => {
    const { marketing_camp } = useContext(ToolContext)
    const { trngForm, trngNewSpkr } = marketing_camp

    const handleLogo = (e, k, action) => {
        const img = action === 'remove' ? '' : URL.createObjectURL(e.target.files[0]);
        trngForm.set((p) => ({ ...p,
            logos: action === 'add' ? [ ...p.logos, { value: img, file: e.target.files[0]} ] : // ADD LOGO
                action === 'change' ? p.logos.map((v, i) => i === k ? { value: img, file: e.target.files[0] } : v ) : // CHANGE LOGO
                p.logos.filter((_, i) => i !== k ), // REMOVE LOGO
        }))
    }

    const handleSpeakers = useCallback((e, k, field, action) => {
        let value, files, imgBlob = '';
        if (action === 'change_text' || action === 'change_img') {
            ({ value, files } = e.target);
            if (action === 'change_img') imgBlob = URL.createObjectURL(files[0]);
        }
        const updatedForm = {
            ...trngForm.data,
            speakers: action === 'add' ? [ ...trngForm.data.speakers, trngNewSpkr.data ] : // ADD SPEAKER
                action === 'remove' ? trngForm.data.speakers.filter((_, i) => i !== k) : // REMOVE SPEAKER
                action === 'change_text' ? trngForm.data.speakers.map((v, i) => i === k ? { ...v, [field]: { ...v[field], value, stat: value.trim() === '' } } : v ): // CHANGE TEXT OF SPEAKER
                trngForm.data.speakers.map((v, i) => i === k ? { ...v, img: { ...v.img, value: imgBlob, file: e.target.files[0] } } : v ) // CHANGE IMG OF SPEAKER
        }
        validateFields(updatedForm)
        trngForm.set(updatedForm)
    }, [trngForm, trngNewSpkr.data, validateFields])

    const handleViolator = (e, action) => {
        const { files, checked } = e.target;
        trngForm.set((p) => ({
            ...p,
            violator: {
                ...p.violator, 
                ...(action === 'change' ? { value: URL.createObjectURL(files[0]), file: files[0] } : { show: checked })
            }
        }));
    };

    const handleChangeDisAndIns = (value) => {
        const updatedForm = { ...trngForm.data, dis_and_ins: { ...trngForm.data.dis_and_ins, value }}
        trngForm.set(updatedForm);
        validateFields(updatedForm);
    }
        

    const memoizeSpeakers = useMemo(() => {
        return trngForm.data?.speakers?.map((v, k) => (
            <Stack key={k} alignItems='start' width='100%' p='1rem' sx={{ borderRadius: '12px', boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.06)'/*'0px 2px 4px 0px #00000014, 0px 0px 6px 0px #00000005'*/ }}>
                { trngForm.data?.speakers.length !== 1 && 
                    <Box width="100%" display="flex" justifyContent="flex-end">
                        <DeleteOutline onClick={() => handleSpeakers(null, k, null, 'remove')} sx={{ cursor: 'pointer', transition: '0.25s', ':hover': { color: 'primary.main' } }} />
                    </Box>
                }
                <Stack gap='1rem' width='100%'>
                    <Stack gap='0.5rem' width='100%'>
                        <Stack direction='row' gap='4px'>
                            <Typography fontSize={14} fontWeight={600}>Name</Typography>
                            <Typography fontSize={14} fontWeight={600} sx={{ color: '#E34935' }}>*</Typography>
                        </Stack>
                        <StndrdTextField size='small' fullWidth value={v.name.value} onChange={(e) => handleSpeakers(e, k, 'name', 'change_text')} error={v.name.stat} multiline inputProps={{ style: { maxHeight: "15rem" } }}/>
                    </Stack>
                    <Stack gap='0.5rem' width='100%'>
                        <Stack direction='row' gap='4px'>
                            <Typography fontSize={14} fontWeight={600}>Description</Typography>
                            <Typography fontSize={14} fontWeight={600} sx={{ color: '#E34935' }}>*</Typography>
                        </Stack>
                        <StndrdTextField fullWidth size='small' value={v.description.value} onChange={(e) => handleSpeakers(e, k, 'description', 'change_text')} error={v.description.stat} multiline inputProps={{ style: { maxHeight: "15rem" } }}/>
                    </Stack>
                    <Stack gap='0.5rem' width='100%'>
                        <Stack direction='row' gap='4px'>
                            <Typography fontSize={14} fontWeight={600}>Company</Typography>
                            <Typography fontSize={14} fontWeight={600} sx={{ color: '#E34935' }}>*</Typography>
                        </Stack>
                        <StndrdTextField size='small' fullWidth value={v.company.value} onChange={(e) => handleSpeakers(e, k, 'company', 'change_text')} error={v.company.stat} multiline inputProps={{ style: { maxHeight: "15rem" } }}/>
                    </Stack>
                    <Stack width='100%'>
                        <Typography fontSize={14} fontWeight={600}>Image</Typography>
                        <Stack justifyContent='center' alignItems='center' width='100%'>
                            <Avatar src={v.img.value} alt={`image${k}`} sx={{ width: 132, height: 132 }}/>
                        </Stack>
                        <Button component="label" variant="outlined" sx={{ px: '24px', mt: '1.5rem', alignSelf: 'center', color: '#003022', borderRadius: '6px', fontSize: '14px', fontWeight: '600', border: '2px solid #003F2E', ':hover': { bgcolor: '#edf3eeff', border: '2px solid #003F2E' } }}>
                                Change
                            <Box component="input" type="file" accept="image/*" hidden onChange={(e) => handleSpeakers(e, k, null, 'change_img')}/>
                        </Button>
                    </Stack>
                </Stack>
            </Stack>    
        ))
    }, [trngForm.data?.speakers, handleSpeakers]);

    return (
        <Stack width='100%' mt='1rem' gap='2rem'>
            <Stack gap='0.5rem' width='100%'>
                <Stack direction='row' justifyContent='space-between' alignItems='center'>
                    <Typography fontWeight={700}>Logo</Typography>
                    <Box component="label" display='flex' alignItems='center' sx={{ cursor: 'pointer', borderRadius: '8px', transition: '0.25s', ':hover': { bgcolor: '#E7E8EA' } }}>
                        <AddBox1 stroke='#003F2E' width={24} height={24}/>
                        <Box component='input' type="file" accept='image/*' hidden name="logos" onChange={(e) => handleLogo(e, 0, 'add')}/>
                    </Box>
                </Stack>
                <Stack width='100%' direction='row' gap='1rem' flexWrap="wrap" justifyContent="center">
                    {trngForm.data?.logos?.map((v, k) => (
                        <Stack key={k} gap='1rem' width="calc(50% - 0.5rem)" position="relative" >
                            <Box position="relative" height="48px" width="100%" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', overflow: 'hidden', '&:hover .delete-icon': { opacity: 1 } }} >
                                <Box component="img" src={v.value} alt={`logo${k}`} sx={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}/>
                                { trngForm.data?.logos.length > 1 &&
                                    <Box className="delete-icon" onClick={(e) => handleLogo(e, k, 'remove')} display="flex" sx={{ opacity: 0, position: 'absolute', top: 4, right: 4, cursor: 'pointer', borderRadius: '6px', transition: '0.25s',':hover': { bgcolor: '#E7E8EA' } }}>
                                        <Clear fontSize="small" />
                                    </Box>
                                }
                            </Box>
                            <Button component="label" variant="outlined" sx={{  px: '24px', alignSelf: 'center', color: '#003022', borderRadius: '6px', fontSize: '14px', fontWeight: '600', border: '2px solid #003F2E', ':hover': { bgcolor: '#edf3eeff', border: '2px solid #003F2E' } }}>
                                Change
                                <Box component="input" type="file" accept="image/*" hidden name="logos" onChange={(e) => handleLogo(e, k, 'change')}/>
                            </Button>
                        </Stack>
                    ))}
                </Stack>
            </Stack>
            <Stack gap='0.5rem' width='100%'>
                <Typography fontWeight={700}>Topic</Typography>
                <Stack width='100%' gap='1rem' alignItems='start'>
                    {/* <FormGroup fullWidth>
                        <FormControlLabel control={<Checkbox/>} label="Connect to POFAcademy?" />
                    </FormGroup> */}
                    <Stack gap='0.5rem' width='100%'>
                        <Stack direction='row' gap='4px'>
                            <Typography fontSize={14} fontWeight={600}>Heading</Typography>
                            <Typography fontSize={14} fontWeight={600} sx={{ color: '#E34935' }}>*</Typography>
                        </Stack>
                        <StndrdTextField name='heading' size='small' fullWidth value={trngForm.data?.heading?.value} onChange={handleChange} error={trngForm.data?.heading.stat} multiline inputProps={{ style: { maxHeight: "15rem" } }}/>
                    </Stack>
                    <Stack gap='0.5rem' width='100%'>
                        <Stack direction='row' gap='4px'>
                            <Typography fontSize={14} fontWeight={600}>Sub-heading</Typography>
                            <Typography fontSize={14} fontWeight={600} sx={{ color: '#E34935' }}>*</Typography>
                        </Stack>
                        <StndrdTextField name='sub_heading' size='small' fullWidth value={trngForm.data?.sub_heading?.value} onChange={handleChange} error={trngForm.data?.sub_heading.stat} multiline inputProps={{ style: { maxHeight: "15rem" } }}/>
                    </Stack>
                    <Stack gap='0.5rem' width='100%'>
                        <Stack direction='row' gap='4px'>
                            <Typography fontSize={14} fontWeight={600}>Title</Typography>
                            <Typography fontSize={14} fontWeight={600} sx={{ color: '#E34935' }}>*</Typography>
                        </Stack>
                        <StndrdTextField name='title' size='small' fullWidth value={trngForm.data?.title?.value} onChange={handleChange} error={trngForm.data?.title.stat} multiline inputProps={{ style: { maxHeight: "15rem" } }}/>
                    </Stack>
                </Stack>
            </Stack>
            <Stack gap='0.5rem' width='100%'>
                <Stack direction='row' justifyContent='space-between' alignItems='center'>
                    <Typography fontWeight={700}>Speakers</Typography>
                    <Box onClick={() => handleSpeakers(null, null, null, 'add')} display='flex' alignItems='center' sx={{ cursor: 'pointer', borderRadius: '8px', transition: '0.25s', ':hover': { bgcolor: '#E7E8EA' } }}>
                        <AddBox1 stroke='#003F2E' width={24} height={24}/>
                    </Box>
                </Stack>
                <Stack gap='1.5rem'>
                    {memoizeSpeakers}
                </Stack>
            </Stack>
            <Stack gap='0.5rem'>
                <Stack direction='row' gap='4px'>
                    <Typography fontWeight={700}>Button Text</Typography>
                    <Typography fontWeight={700} sx={{ color: '#E34935' }}>*</Typography>
                </Stack>
                <StndrdTextField name='button' value={trngForm.data?.button?.value} onChange={handleChange} size='small' fullWidth error={trngForm.data?.button.stat} multiline inputProps={{ style: { maxHeight: "15rem" } }}/>
            </Stack>
            <Stack gap='0.5rem'>
                <Stack direction='row' gap='4px'>
                    <Typography fontWeight={700}>Time</Typography>
                    <Typography fontWeight={700} sx={{ color: '#E34935' }}>*</Typography>
                </Stack>
                <StndrdTextField name='time' value={trngForm.data?.time?.value} onChange={handleChange} size='small' fullWidth error={trngForm.data?.time.stat} multiline inputProps={{ style: { maxHeight: "15rem" } }}/>
            </Stack>
            <Stack gap='0.5rem'>
                <Stack direction='row' gap='4px'>
                    <Typography fontWeight={700}>Date</Typography>
                    <Typography fontWeight={700} sx={{ color: '#E34935' }}>*</Typography>
                </Stack>
                <StndrdTextField name='date' value={trngForm.data?.date?.value} onChange={handleChange} size='small' fullWidth error={trngForm.data?.date.stat} multiline inputProps={{ style: { maxHeight: "15rem" } }}/>
            </Stack>
            <Stack gap='0.5rem'>
                <Stack direction='row' gap='4px'>
                    <Typography fontWeight={700}>Location</Typography>
                    <Typography fontWeight={700} sx={{ color: '#E34935' }}>*</Typography>
                </Stack>
                <StndrdTextField name='location' value={trngForm.data?.location?.value} onChange={handleChange} size='small' fullWidth error={trngForm.data?.location.stat} multiline inputProps={{ style: { maxHeight: "15rem" } }}/>
            </Stack>
            <Stack gap='0.5rem'>
                <Stack direction='row' gap='4px'>
                    <Typography fontWeight={700}>Discussion and Insights</Typography>
                    <Typography fontWeight={700} sx={{ color: '#E34935' }}>*</Typography>
                </Stack>
                <Box height='15rem' sx={{ "& .ql-container": { borderWidth: '0px', height: "calc(15rem - 66.6875px)" }, "& .ql-toolbar": { borderWidth: "0px 0px 1px"} }}>
                    <ReactQuill
                        value={trngForm.data?.dis_and_ins?.value}
                        onChange={handleChangeDisAndIns}
                        modules={{
                            toolbar: [
                                ["bold", "italic", "underline"],
                                [
                                    { align: "" }, // for left
                                    { align: "center" },
                                    { align: "right" },
                                    { align: "justify" },
                                ],
                                [{ list: "ordered" }, { list: "bullet" }],
                            ],
                        }}
                        style={{
                            backgroundColor: "#ffffff",
                            borderRadius: "5px",
                            border: `1px solid ${trngForm.data?.dis_and_ins?.value.replace(/<[^>]*>/g, '').trim() === '' ? '#E34935' : 'rgba(0,0,0,0.2)'}`,
                        }}
                    />
                </Box>
            </Stack>
            <Stack gap='0.5rem'>
                <Stack direction='row' justifyContent='space-between' alignItems='center'>
                    <Typography fontWeight={700}>Violator</Typography>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={trngForm.data?.violator.show} onChange={(e) => handleViolator(e, 'show_hide')}/>} label="Show" />
                    </FormGroup>
                </Stack>
                <Stack alignItems='center'>
                    <Box component="img" src={trngForm.data?.violator.value} alt={`violater_img`} width={113.74} height={32} sx={{ objectFit: 'contain' }}/>
                </Stack>
                <Button component="label" variant="outline" sx={{ mt: '1rem', px: '24px', alignSelf: 'center', color: '#003022', borderRadius: '6px', fontSize: '14px', fontWeight: '600', border: '2px solid #003F2E', ':hover': { bgcolor: '#edf3eeff', border: '2px solid #003F2E' } }}>
                    Change
                    <Box component="input" type="file" accept="image/*" hidden onChange={(e) => handleViolator(e, 'change')}/>
                </Button>
            </Stack>
        </Stack>
    )
}

export default React.memo(Content);